import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getQuoteCollaboratorsListAPI = (spotQuoteId: string) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/collaborators/${spotQuoteId}`,
    method: 'get',
  });
};

export type QuoteCollaboratorsListResponse = any;

export const fetchQuoteCollaboratorsList = async (spotQuoteId: string): Promise<QuoteCollaboratorsListResponse> => {
  const response: AxiosResponse<QuoteCollaboratorsListResponse> = await getQuoteCollaboratorsListAPI(spotQuoteId);
  return response.data;
};
